export default "__VITE_ASSET__CtAfyzZ2__"